module.exports = __webpack_public_path__ + "static/media/company-introduction-4.811a7f49.jpg";